angular
    .module('festzelt-os.components')
    .factory('restoreSelected', restoreSelected);

function restoreSelected() {
    return {
        key: 'restore-selected',
        title: 'Restore selected',
        level: 'archivedSelected',
        manager: 'restoreMany'
    }
}



// WEBPACK FOOTER //
// ./src/app/components/workflows/general/restore-selected.js